export const STATIC_LINKS = [
    {
      content: 'About us',
      url: '/about-us',
      templateKey: 'aboutUs'
    },
    {
      content: 'Privacy Policy',
      url: '/privacy-policy',
      templateKey: 'privacyPolicy'
    },
    {
      content: 'Work with Us',
      url: '/work-with-us',
      templateKey: 'workWithUs'
    },
    {
      content: 'Advertise with Us',
      url: '/advertise-with-us',
      templateKey: 'advertiseWithUs'
    },
    {
      content: 'Contact Us',
      url: '/contact-us',
      templateKey: 'contactUs'
    },
    {
      content: 'Terms & Conditions',
      url: '/terms-and-conditions',
      templateKey: 'termsAndConditions'
    },
    {
      content: 'Our Team',
      url: '/our-team',
      templateKey: 'ourTeam'
    },
    {
      content: 'Suppliers',
      url: '/suppliers',
      templateKey: 'suppliers'
    },
    {
      content: 'Awards',
      url: '/awards',
      templateKey: 'awards'
    }

  ]
